import { render, staticRenderFns } from "./holdingYardMilkShed.vue?vue&type=template&id=71168f5d&"
import script from "./holdingYardMilkShed.vue?vue&type=script&lang=js&"
export * from "./holdingYardMilkShed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports